import React, { useState, useEffect } from 'react'
import Accordion from 'react-bootstrap/Accordion';
import Select from 'react-select';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Address from './GeneralTabs/Address';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getBranchList } from '../../../../Redux/action/Organisation/Branch/BranchAction';
import Beatloader from '../../../../Common/Loaders/Beatloader';
import MoreAddresses from './GeneralTabs/MoreAddresses';
import AccountManagers from './GeneralTabs/AccountManagers';
import CustomDetails from './GeneralTabs/CustomDetails';
import CompanyDetails from './BasicTabs/CompanyDetails';
import BankDetails from './BasicTabs/BankDetails';
import Documentation from './BasicTabs/Documentation';
import Declaration from './BasicTabs/Declaration';

const BasicTab = ({ token, user_id, b64id,refresh }) => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [branch_id, setBranch_id] = useState(0);
    const [branch_country_id, setBranch_country_id] = useState(0);
    const [showLoader, setShowLoader] = useState(false);
    const [branchListing, setBranchListing] = useState([]);
    const [activeTab, setActiveTab] = useState("home"); // State to track the active tab

    const handleGoToFirstTab = () => {
        setActiveTab("home"); // Set the active tab to "home"
    };



    useEffect(() => {
        if (token && user_id && b64id) {
            let id = atob(b64id);
            if (id) {
                dispatch(getBranchList(token, user_id, id))
            }
        }
    }, [token, user_id, b64id]);

    const refreshData = () => {
        if (token && user_id && b64id) {
            let id = atob(b64id);
            if (id) {
                dispatch(getBranchList(token, user_id, id))
            }
        }
    };

    const { loadingBranchList, BranchListError, BranchList } = useSelector(state => state?.BranchReducer);

    useEffect(() => {
        if (loadingBranchList) {
            setShowLoader(true)
        } else {
            setShowLoader(false)
        };


        if (BranchList) {
            setBranchListing(BranchList)
        }
    }, [loadingBranchList, BranchListError, BranchList])

    return (
        <>
            {
                showLoader ?
                    <Beatloader />
                    :
                    <>
                        <div className="card">
                            <div className="card-body">
                                <CompanyDetails customer_id={atob(b64id)} disableInput={false} refresh={refresh}/>
                                <BankDetails customer_id={atob(b64id)} disableInput={false} />
                                <Documentation customer_id={atob(b64id)} disableInput={false} />
                                <Declaration customer_id={atob(b64id)} disableInput={false} />
                            </div>
                        </div>
                    </>
            }
        </>

    )
}

export default BasicTab